import { PRODUCT_TYPE_STRUCTURE_TYPES } from '../constants/products.constants';

export interface IProductExtendedStructureType {
  pieces: boolean;
  complex: boolean;
  piecesGroup: boolean;
}

export function isComplexStructureType(structureType: string): boolean {
  return PRODUCT_TYPE_STRUCTURE_TYPES.COMPLEX === structureType;
}

export function isPiecesGroupStructureType(structureType: string): boolean {
  return PRODUCT_TYPE_STRUCTURE_TYPES.PIECES_GROUP === structureType;
}

export function isPiecesStructureType(structureType: string): boolean {
  return PRODUCT_TYPE_STRUCTURE_TYPES.PIECES === structureType;
}

export function isPiecesOrPiecesGroup(structureType: string): boolean {
  return [PRODUCT_TYPE_STRUCTURE_TYPES.PIECES,
    PRODUCT_TYPE_STRUCTURE_TYPES.PIECES_GROUP].indexOf(structureType as any) >= 0;
}

export function getProductExtendedStructureType(structureType: string): IProductExtendedStructureType {
  return {
    pieces: isPiecesStructureType(structureType),
    complex: isComplexStructureType(structureType),
    piecesGroup: isPiecesGroupStructureType(structureType),
  };
}
